/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { forwardRef, ForwardedRef } from 'preact/compat';
import { classNames } from '../utils/UNSAFE_classNames';
import { styles } from './themes/FocusTrackerStyles.css';

type Props = {
  onFocus: (event: FocusEvent) => void;
};

/**
 * Styled FocusTrap sub-component to render non-visible focus guards
 */
export const FocusGuard = forwardRef(
  ({ onFocus }: Props, guardRef: ForwardedRef<HTMLDivElement>) => {
    const classes = classNames([styles.guardStyle]);

    return <div class={classes} onFocus={onFocus} ref={guardRef} tabIndex={0} />;
  }
);
